const AUTH_KEY = 'signal_auth';

export const getAuth = () => {
  try {
    const stored = localStorage.getItem(AUTH_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const setAuth = (data) => {
  localStorage.setItem(AUTH_KEY, JSON.stringify(data));
};

export const clearAuth = () => {
  localStorage.removeItem(AUTH_KEY);
};

export const getAuthHeader = () => {
  const auth = getAuth();
  return auth?.token ? { Authorization: `Bearer ${auth.token}` } : {};
};
